import { IClassname } from '@/lib/shared/model/classname';

export const HairDryer = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.33245 11.5269L1.94287 12.8048V3.85938L8.33245 5.13729V11.5269Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33252 5.13785L23.6675 2.61652C24.4704 2.52819 25.2829 2.60999 26.0521 2.8566C26.8213 3.10322 27.5299 3.50911 28.1318 4.04784C28.7336 4.58657 29.2153 5.24605 29.5453 5.98332C29.8752 6.7206 30.0462 7.51912 30.047 8.32687C30.0478 9.13463 29.8785 9.93349 29.55 10.6714C29.2215 11.4094 28.7412 12.0698 28.1404 12.6097C27.5396 13.1497 26.8318 13.557 26.0631 13.8052C25.2945 14.0533 24.4821 14.1368 23.679 14.05L8.33252 11.5274"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.7396 11.9951L27.5984 23.1347C27.5718 23.4549 27.4255 23.7534 27.1886 23.9705C26.9518 24.1877 26.6418 24.3077 26.3205 24.3066H22.5008C22.3237 24.3072 22.1484 24.271 21.986 24.2002C21.8236 24.1295 21.6777 24.0257 21.5575 23.8956C21.4374 23.7654 21.3456 23.6118 21.288 23.4443C21.2304 23.2767 21.2082 23.0991 21.2229 22.9226L22.1954 13.8072"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.4181 29.4183H26.8622C26.1844 29.4183 25.5343 29.149 25.055 28.6697C24.5757 28.1904 24.3064 27.5403 24.3064 26.8625V24.3066"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
